<script setup lang="ts">
defineProps<{
  eyebrow: string;
  title: string;
  description?: string;
  align?: 'center' | 'start';
}>();
</script>

<template>
  <div :class="['section-heading', `section-heading--${align ?? 'center'}`]">
    <span class="eyebrow">{{ eyebrow }}</span>
    <h2>{{ title }}</h2>
    <p v-if="description">{{ description }}</p>
  </div>
</template>
